import { render, staticRenderFns } from "./PromotionalBanners.vue?vue&type=template&id=ad141644&scoped=true&"
import script from "./PromotionalBanners.vue?vue&type=script&lang=js&"
export * from "./PromotionalBanners.vue?vue&type=script&lang=js&"
import style0 from "./PromotionalBanners.vue?vue&type=style&index=0&id=ad141644&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad141644",
  null
  
)

export default component.exports